import {
  FETCH_KILLSWITCH_ASYNC,
  FETCH_ORIGINAL_SUBJECT_ASYNC,
  FETCH_SETTINGS_ASYNC,
  SAVE_SETTINGS_ASYNC,
  UPDATE_KILLSWITCH_ASYNC,
  UPDATE_ORIGINAL_SUBJECT_ASYNC,
  UPDATE_SILENT_MODE_ASYNC,
  UPDATE_STATUS_ASYNC,
} from './constants'

export const fetchSettings = () => ({ type: FETCH_SETTINGS_ASYNC.INITIATE })
export const fetchSettingsSuccess = (data) => ({
  type: FETCH_SETTINGS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchSettingsError = (error) => ({ type: FETCH_SETTINGS_ASYNC.ERROR, error })

export const fetchKillswitchStatus = () => ({ type: FETCH_KILLSWITCH_ASYNC.INITIATE })
export const fetchKillswitchStatusSuccess = (data) => ({
  type: FETCH_KILLSWITCH_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchKillswitchStatusError = (error) => ({
  type: FETCH_KILLSWITCH_ASYNC.ERROR,
  error,
})

export const updateStatus = (status) => ({ type: UPDATE_STATUS_ASYNC.INITIATE, payload: status })
export const updateStatusSuccess = (data) => ({
  type: UPDATE_STATUS_ASYNC.SUCCESS,
  payload: { data },
})
export const updateStatusError = (error) => ({ type: UPDATE_STATUS_ASYNC.ERROR, error })

export const updateSilentMode = (silentMode) => ({
  type: UPDATE_SILENT_MODE_ASYNC.INITIATE,
  payload: silentMode,
})
export const updateSilentModeSuccess = (data) => ({
  type: UPDATE_SILENT_MODE_ASYNC.SUCCESS,
  payload: { data },
})
export const updateSilentModeError = (error) => ({ type: UPDATE_SILENT_MODE_ASYNC.ERROR, error })

export const saveSettings = (payload) => ({ type: SAVE_SETTINGS_ASYNC.INITIATE, payload })
export const saveSettingsSuccess = (data) => ({
  type: SAVE_SETTINGS_ASYNC.SUCCESS,
  payload: { data },
})
export const saveSettingsError = (error) => ({ type: SAVE_SETTINGS_ASYNC.ERROR, error })

export const updateKillswitch = (action) => ({
  type: UPDATE_KILLSWITCH_ASYNC.INITIATE,
  payload: action,
})
export const updateKillswitchSuccess = (data) => ({
  type: UPDATE_KILLSWITCH_ASYNC.SUCCESS,
  payload: { data },
})
export const updateKillswitchError = (error) => ({
  type: UPDATE_KILLSWITCH_ASYNC.ERROR,
  error,
})

export const fetchOriginalSubject = () => ({ type: FETCH_ORIGINAL_SUBJECT_ASYNC.INITIATE })
export const fetchOriginalSubjectSuccess = (data) => ({
  type: FETCH_ORIGINAL_SUBJECT_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchOriginalSubjectError = (error) => ({
  type: FETCH_ORIGINAL_SUBJECT_ASYNC.ERROR,
  error,
})

export const updateOriginalSubject = (useOriginalSubject) => ({
  type: UPDATE_ORIGINAL_SUBJECT_ASYNC.INITIATE,
  payload: useOriginalSubject,
})
export const updateOriginalSubjectSuccess = (data) => ({
  type: UPDATE_ORIGINAL_SUBJECT_ASYNC.SUCCESS,
  payload: { data },
})
export const updateOriginalSubjectError = (error) => ({
  type: UPDATE_ORIGINAL_SUBJECT_ASYNC.ERROR,
  error,
})

export default {
  fetchSettings,
  fetchKillswitchStatus,
  updateStatus,
  updateSilentMode,
  saveSettings,
  updateKillswitch,
  fetchOriginalSubject,
  updateOriginalSubject,
}
